<pp-filter-field-numbers-input
  class="advancedFilterNumberInput"
  [ppPlaceholder]="'enter_number' | ppTranslate"
  [ppLeftUnit]="ppUnitPosition === ENumberInputUnitPosition.LEFT"
  [(ppValue)]="ppValue"
  [ppUnit]="ppUnit"
  (ppValueChange)="onChange(ppValue)"
  [ppDecimalPlaces]="ppDecimalPlaces"
  [ppShowComma]="ppShowCommas"
></pp-filter-field-numbers-input>
